import { useState } from "react";
import { ICategory } from "../category.props";
import { useNavigate } from "react-router-dom";
import ApiService from "../../../service/ApiService";
import { apiPaths } from "../../../service/apiPaths";
import toast from "react-hot-toast";

const useAddCategory = () =>{
const [formData , setFormData] = useState<ICategory>({name:"" , description:""})
const [loading , setLoading] = useState<boolean>(false)
const navigate = useNavigate()
const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { id, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  const handleSubmit  = async () => {
    try {
      setLoading(true);
      const response = await ApiService({
        method: "POST",
        endpoint: `${apiPaths.createCouponCategory}`,
        data: formData,
       
      });

      toast.success("Category added successfully", {
        duration: 10000,
      });
      navigate("/coupon-category");
    } catch (error) {
      toast.error("Error adding category", {
        duration: 10000,
      });
      console.error("Error adding category:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    navigate("/coupon-category");
  };
  return {handleCancel , handleChange , handleSubmit , loading , formData }
}
export default useAddCategory
